import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';
import { useTranslation } from 'react-i18next';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import * as types from 'data/collectionFunctionGroup/collectionFunctionGroup.types';
import Form, {
  FieldUpdateHandlerParam,
} from 'shared/form';
import './collection-function-group-form.scss';
import { FormLayout } from 'components/FormLayout';

type Props = {
  template: FormTemplate,
  data: Partial<types.CollectionFunctionGroupFormData>
  i18nKeyPrefix?: string
  onFieldUpdate?: (param: FieldUpdateHandlerParam, formSection?: 'main') => void
}

export type Ref = {
  isValid: (forceValidation: boolean, forceTouched: boolean) => boolean
  getValues: () => types.CollectionFunctionGroupFormData
}

export const COLLECTION_FUNCTION_GROUP_I18N_KEY = 'collectionFunctionGroup.form';

export const CollectionFunctionGroupForm = forwardRef<Ref, Props>(({
  template,
  data,
  i18nKeyPrefix = COLLECTION_FUNCTION_GROUP_I18N_KEY,
  onFieldUpdate = () => null,
}: Props, ref) => {
  const mainRef = useRef<Form>(null);
  const { t } = useTranslation();

  const isValid = (forceValidation = false, forceTouched = true) => {
    const isMainValid = mainRef.current?.isValid(forceValidation, forceTouched) ?? true;
    return isMainValid;
  };

  const getValues = () => {
    const formValues: types.CollectionFunctionGroupFormData = {
      ...mainRef.current?.getValues(),
    };

    return formValues;
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getValues,
  }));

  const onMainFieldUpdate = (param: FieldUpdateHandlerParam) => onFieldUpdate(param, 'main');

  return (
    <div className="collection-function-group-form" data-testid="CollectionFunctionGroupForm">
      <div data-testid="CollectionFunctionGroupFormMain">
        <FormLayout>
          <Form
            ref={mainRef}
            name={template.formId ?? template.key}
            defaults={data}
            fields={(template.main as FormTemplateSection).fields}
            layout={(template.main as FormTemplateSection).metadata.layout?.rows}
            i18nKeyPrefix={i18nKeyPrefix}
            fieldUpdateHandler={onMainFieldUpdate}
          />
        </FormLayout>
      </div>
      <span className="collection-function-group-form-note">{t('collectionFunctionGroup.form.note')}</span>
    </div>
  );
});

export default CollectionFunctionGroupForm;
